// The AWIN/Fnac datafeed fills the image field of some events with Fnac's own
// "no image" stand-in, `https://www.fnacspectacles.com/obj/media/FR-eventim/
// teaser/blank.gif`, which 404s. sync-awin-fnac stores null for it instead
// (same rule there — keep the two in sync), and a migration cleared the rows
// synced before that (20261015130000_drop_fnac_placeholder_images.sql). This
// guards whatever still carries it — rows synced before the fixed function was
// deployed, seeds baked from them — so a card or hero shows NoImagePlaceholder
// without a doomed request, and no page declares the dead URL as its
// og:image / twitter:image / JSON-LD image.

const PLACEHOLDER = /\/blank\.gif(?:[?#]|$)/i;

/** The URL, or null when there's none or it's a known placeholder that never loads. */
export function usableImageUrl(url: string | null | undefined): string | null {
  return url && !PLACEHOLDER.test(url) ? url : null;
}
